import React, { Component } from 'react';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import * as Actions from '../../../store/actions/coursePage';
import { Log, Level, Logger } from 'ng2-logger';
import { IStudentPageProps, IStudentPageState, StudentSearchInitialValues } from '../../../models/components/course-student-list';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../../models/action/core';

const _logger = Log.create('Progress-Percent');
const T = Translator.create();

export class ProgressPercent extends React.Component<any, any> {

    public async getProgressPercent() {
        this.props.dispatch(Actions.getProgressPercent(this.props.classId!, this.props.userId, 'getProgressPercent', 'get'));
    }

    public componentDidMount() {
        this.getProgressPercent();
    }

    public componentDidUpdate(prevProps: any) {
        if (prevProps.classId !== this.props.classId) {
            this.getProgressPercent();
        }
    }

    public render() {
        return (
            <div
                className={this.props.progress >= 25 && this.props.progress <= 99 ? 'mobil-progress course-percentage course-percentage-two' : 'course-percentage mobil-progress'}>
                <div className="d-flex justify-content-between">
                    <small className="pr-2">{T.t('course_progress_percent')}</small>
                    {this.props.progress >= 0 && this.props.progress <= 24 ? (<div className="countYellow mobile-count-yellow">{this.props.progress + '%'}</div>) : ('')}
                    {this.props.progress >= 25 && this.props.progress <= 99 ? <div className="count mobile-count">{this.props.progress + '%'}</div> : ''}
                    {this.props.progress === 100 ? <div className="countOk mobile-count-ok"> <i className="material-icons mr-1 icon-rtl">done</i> </div> : ''}
                </div>
                <div className="bar mobil-bar">
                    <div style={{ width: (this.props.progress + '%') }} className="bar-width mobil-bar-progress" />
                </div>
                {this.props.progress >= 0 && this.props.progress <= 24 ? <p>👋🏼 {T.t('progress_percent_message_one')}</p> : ''}
                {this.props.progress >= 25 && this.props.progress <= 99 ? <p>😀 {T.t('progress_percent_message_two')}</p> : ''}
                {this.props.progress === 100 ? <p>😎 {T.t('progress_percent_message_three')}</p> : ''}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IStudentPageProps): IStudentPageProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IStudentPageProps = Object.assign({}, ownProps, {
        progress: state.coursePage.progress ? state.coursePage.progress : '0'
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CProgressPercent = connect(mapStateToProps, dispatchProps)(ProgressPercent);

export default CProgressPercent;
